import emitter from './emitter';
import getEntry from './getEntry';

function invalidate(ctx, endpoint, input, options) {
  const entry = getEntry(ctx, endpoint, input, options);
  if (entry) {
    entry.cacheTime = 0;
    entry.error = null;
    entry.version++;
    emitter.emit('update', { endpoint });
  }
}

function invalidateEndpoint(ctx, endpoint) {
  const entriesForResource = ctx.cache.entries.get(endpoint);
  if (entriesForResource !== undefined) {
    entriesForResource.forEach(entry => {
      entry.cacheTime = 0;
      entry.error = null;
      entry.version++;
    });
  }
  emitter.emit('update', { endpoint });
}

function invalidateEndpoints(ctx, endpoints) {
  endpoints.forEach(endpoint => {
    const entriesForResource = ctx.cache.entries.get(endpoint);
    if (entriesForResource !== undefined) {
      entriesForResource.forEach(entry => {
        entry.cacheTime = 0;
        entry.error = null;
        entry.version++;
      });
    }
  });
  emitter.emit('update', {});
}

function setCacheValue(ctx, endpoint, input, value, options) {
  const entry = getEntry(ctx, endpoint, input, options);
  if (entry) {
    entry.value = value;
    entry.version++;
    emitter.emit('update', { endpoint });
  } else {
    const now = Date.now();
    const {
      cache: { entries },
    } = ctx;
    let entriesForResource = entries.get(endpoint);

    if (entriesForResource === undefined) {
      entriesForResource = new Map();
      entries.set(endpoint, entriesForResource);
    }
    const key = options.stringifyInput(input);
    const newEntry = {
      value: value ?? null,
      promise: null,
      error: null,
      fetchedAt: now,
      resolvedAt: now,
      cacheTime: options.cacheTime,
      queuedRefetch: false,
      version: 1,
      key,
    };
    entriesForResource.set(key, newEntry);
  }
}

export default invalidate;
export { invalidateEndpoint, invalidateEndpoints, setCacheValue };
